module.exports = __webpack_public_path__ + "media/file3.mp4";